import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from "gsap";
import curDot from 'cursor-dot';
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);
const scroll = new LocomotiveScroll({
    lenisOptions: {
        smoothTouch: true,
    },
});

document.addEventListener('DOMContentLoaded', () => {
    const cur = curDot({
        zIndex: 1e5,
        diameter: 20,
        easing: 6,
        borderWidth: 1,
        borderColor: "#27529F",
        background: "#27529F",
        blendMode: "normal"
    });
    cur.over("a:not(.hover-link), input, textarea, .cursor-pointer", {
        scale: 4,
        background: "transparent",
        borderWidth: 4,
    }),
        cur.over(".swiper.cases", {
            scale: 4,
            background: "transparent",
            borderWidth: 4,
            borderColor: "#fff",
            blendMode: "screen"
        }),
        cur.over(".swiper.tiles", {
            scale: 4,
            background: "transparent",
            borderWidth: 4,
            borderColor: "#1e3261",
            blendMode: "screen"
        }),
        cur.over(".hover-link", {
            scale: 5,
            background: "#1e3261",
            borderColor: "#1e3261",
            blendMode: "normal"
        }),
        cur.over(".hover-link-light", {
            scale: 5,
            background: "#27529F",
            blendMode: "normal"
        }),
        cur.over(".feature-text a", {
            scale: 5,
            borderColor: "#000",
            blendMode: "normal"
        }),
        cur.over(".filters", {
            //background: "#1e3261",
            borderColor: "#1e3261",
            blendMode: "normal"
        }),
        cur.over(".case-listings article a", {
            scale: 8,
            background: "#27529F",
            blendMode: "screen"
        }),
        cur.over("#hero", {
            scale: 8,
            background: "#27529F",
            blendMode: "screen"
        });
    const t = document.querySelectorAll(".hover-link, .hover-link-light");
    setTimeout((function () {
        Array.prototype.forEach.call(t, (e => {
            let t = e.dataset.hover;
            e.addEventListener("mouseover", (e => {
                document.querySelector(".cursor-dot").innerHTML = `<span>${t}</span>`
            }
            )),
                e.addEventListener("mouseout", (e => {
                    document.querySelector(".cursor-dot").innerHTML = ""
                }
                ))
        }
        ));
        const e = document.querySelectorAll(".feature-text .text a");
        Array.prototype.forEach.call(e, (e => {
            e.addEventListener("mouseover", (e => {
                document.querySelector(".cursor-dot").innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n                        <path fill="#000" d="M509.7 261.7c3.125-3.125 3.125-8.188 0-11.31l-152-152c-1.6-1.61-3.6-3.29-5.7-3.29s-4.094.7813-5.656 2.344c-3.125 3.125-3.125 8.188 0 11.31l138.3 138.3H8c-4.406 0-8 3.578-8 8 0 5.346 3.594 8.046 8 8.046h476.7L346.4 401.4c-3.125 3.125-3.125 8.188 0 11.31s8.188 3.125 11.31 0L509.7 261.7z"/>\n                        </svg>'
            }
            )),
                e.addEventListener("mouseout", (e => {
                    document.querySelector(".cursor-dot").innerHTML = ""
                }
                ))
        }
        ))
    }
    ), 100);
});

document.querySelectorAll(".feature-text a").forEach((e => {
    let t = e.getBoundingClientRect()
        , i = e.querySelector(".subtext")
        , s = gsap.to(i, {
            duration: 1,
            ease: "power3",
            left: 0 // You need to set an initial value for 'left'
        });
    e.addEventListener("mousemove", (e => {
        let posX = e.clientX - t.left;
        gsap.to(i, {
            duration: 1,
            ease: "power3",
            left: posX // Update the 'left' property on mouse move
        });
    }));
}));

const caseCarousel = document.querySelector('.case-carousel .swiper');
if (caseCarousel) {
    const caseSwiper = new Swiper(caseCarousel, {
        initialSlide: 1,
        loop: true,
        loopAdditionalSlides: 1,
        loopPreventsSliding: false,
        slidesPerView: 1,
        speed: 800,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    });
    caseSwiper.el.addEventListener('click', function (event) {
        // Get the slide element from the event target
        const slide = event.target.closest('.swiper-slide');

        if (slide) {
            console.log(slide.classList);
            if (slide.classList.contains('swiper-slide-next')) {
                caseSwiper.slideNext();
            } else if (slide.classList.contains('swiper-slide-prev')) {
                caseSwiper.slidePrev();
            }

            // Prevent default link behavior and stop event propagation
            const link = event.target.closest('a');
            if (link && (slide.classList.contains('swiper-slide-next') || slide.classList.contains('swiper-slide-prev'))) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    });
}

const clientSwiperElements = document.querySelectorAll('.logo-tiles .swiper');
if (clientSwiperElements) {
    clientSwiperElements.forEach((swiperElement) => {
        const isReverse = swiperElement.classList.contains('swiper-reverse');
        new Swiper(swiperElement, {
            loop: true,
            slidesPerView: 2,
            speed: 800,
            spaceBetween: 30,
            autoplay: {
                delay: 5000,
                reverseDirection: isReverse,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    });
}

const masonryImagesSwiper = document.querySelectorAll('.masonry .swiper');
if (masonryImagesSwiper) {
    masonryImagesSwiper.forEach((swiperElement) => {
        new Swiper(swiperElement, {
            loop: true,
            slidesPerView: 1,
            speed: 800,
            // effect: 'fade',
            autoplay: {
                delay: 3000,
            },
        });
    });
}

const accordion = document.querySelectorAll('.accordion .accordion-item .title-wrap');
if (accordion) {
    accordion.forEach((item) => {
        item.addEventListener('click', () => {
            item.parentElement.classList.toggle('active');
        });
    });
}

const filterSelect = document.querySelector('#posts-filter .select-filter');
if (filterSelect) {
    filterSelect.addEventListener('click', () => {
        filterSelect.parentElement.classList.toggle('active');
    });

    // Close dropdown when click outside
    document.addEventListener('click', (e) => {
        if (!filterSelect.contains(e.target)) {
            filterSelect.parentElement.classList.remove('active');
        }
    });
}

const heroBg = document.querySelector('.hero-bg');

if (heroBg) {
    document.addEventListener('scroll', function () {
        // Get the current scroll position
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Get the maximum scroll position
        const maxScrollTop = heroBg.clientHeight * 3;

        // Calculate the scroll progress
        const progress = scrollTop / maxScrollTop;

        // Calculate the new opacity
        const opacity = 1 - progress * 5;

        // Update the opacity
        heroBg.style.opacity = opacity;
    });
}